/**
 * Trigger finance calculator tab
 */
$(document).ready(function () {
    'use strict';

    if ($('.itemMainTabs').length && location.hash === '#finance-calculator') {
        triggerFinanceCalculator();
    }

    $(document).on('click', '.js_triggerFinanceCalculatorTab', function (e) {
        e.preventDefault();
        triggerFinanceCalculator(true);
    });
});

const triggerFinanceCalculator = (scrollToView = false) => {
    if ($('.itemImageOverlay').length) {
        $('.overlayCloseButton').trigger('click');
    }

    if (matchesMediaQuery(768)) {
        const tabsMenu = $('.js_newItemTabsMenu'),
            menuItem = tabsMenu.find('li[data-tab="finance-calculator"] > a');

        // if we find the menu item
        if (menuItem.length > 0) {

            if (scrollToView) {
                // scroll to tabs
                $('body, html').stop(true, false).animate({
                    scrollTop: tabsMenu.offset().top - 30
                }, 400);
            }

            // trigger a click
            menuItem.trigger('click');
        }
    } else {
        // accordions
        const accordions = $('.newItemTabs'),
            accordionItem = accordions.find('.newItemTab[data-tab="finance-calculator"]');

        if (accordionItem.length > 0) {
            // get title
            const accordionItemTitle = accordionItem.find('.newItemTabTitle > a');

            if (scrollToView) {
                // scroll to tabs
                $('body, html').stop(true, false).animate({
                    scrollTop: accordions.offset().top - 30
                }, 400);
            }

            // trigger a click
            accordionItemTitle.trigger('click');
        }
    }
}